<template lang="pug">
  .component-backoffice-create-zone
    .row
      .column.small-12.large-6
        label Name
          input(type="text", v-model="body.name")

    .row.column
      label Add from geojson
        textarea(v-model="body.poly", rows="10")
      GoogleMapContainer
        GoogleMap(
          :search-bar="true",
          style="height:500px", ref="map", :api-key="apiKey",
          :center="mapCenter", v-if="mapCenter.lat !== 0 && mapCenter.lng !== 0", :libraries="['places','visualization','drawing']", :zoomControl="true", :mapTypeControl="true")
          GoogleMapDrawingManager(@updated="shapeUpdated")
      button.button(:disabled="!body.name || !body.poly", @click="createZone") Create

</template>

<script>
  import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
  import MaggieHelper from '../../maggieHelper'
  import GoogleMap from '../../lib/map/GoogleMap.vue'
  import GoogleMapDrawingManager from '../../lib/map/GoogleMapDrawingManager'
  import {mapState} from 'vuex'
  import GoogleMapContainer from '../../components/backoffice/GoogleMapContainer'

  export default {
    name: 'CreateZone',
    components: {GoogleMapContainer, GoogleMap, GoogleMapDrawingManager},
    data() {
      return {
        apiKey: null,
        geoData: null,
        body: {
          name: null,
          poly: null
        },
        mapCenter: {
          lat: 0,
          lng: 0,
        }
      }
    },
    created() {
      this.apiKey = window.env.GOOGLE_MAPS_KEY
    },
    methods: {
      shapeUpdated(data) {
        this.body.poly = data
      },
      createZone() {
        KeplerBackofficeSdk.zones.make(this.body, () => {
          MaggieHelper.notification('Zone', 'Zone created successfully')
          this.$router.push({path: 'assets', name: 'zone-management'})
        })
      }
    },
    computed: {
      ...mapState({
        configuration: state => state.configuration,
      }),
    },
    mounted() {
      KeplerBackofficeSdk.configuration.get((data) => {
        this.mapCenter.lat = data.application.application_default_latitude.value
        this.mapCenter.lng = data.application.application_default_longitude.value
      })
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// CreateZone.vue?21b3a7b8